import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { BillingService } from '@galaxy/billing';
import { getPriceValueForEdition } from '@vendasta/billing-ui';
import { convertCentsToDollars } from '@vendasta/shared';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';
import { OrderConfirmationItem } from '../../../confirmation-page/interface';
import { ActivationParamService } from '../../../core/activation-param.service';
import { ProductOrderFormStoreService } from '../../../core/product-order-form.store.service';
import { getInitInputValue, updateOrderCustomPrice } from '../../custom-price.util';

@Component({
  selector: 'app-order-form-custom-price-form',
  templateUrl: './apps-custom-price-form.component.html',
  styleUrls: ['./apps-custom-price-form.component.scss'],
  standalone: false,
})
export class AppsCustomPriceFormComponent implements OnInit, OnDestroy {
  @Input()
  item: OrderConfirmationItem;
  minValue = 0;
  private subscriptions: Subscription[] = [];
  partnerCurrency$: Observable<string>;
  partnerId$: Observable<string>;

  constructor(
    private billingService: BillingService,
    private paramService: ActivationParamService,
    private productOrderFormService: ProductOrderFormStoreService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.minValue =
      getPriceValueForEdition(
        this.item.appPrices.pricesForContexts['wholesale'],
        this.item.partnerCurrency,
        this.item.editionId || '',
        false,
      ) || 0;

    this.partnerId$ = this.paramService.partnerId$;

    this.partnerCurrency$ = this.partnerId$?.pipe(
      switchMap((partnerId) =>
        this.billingService.getMultiContract([partnerId]).pipe(
          map((resp) => {
            return resp[partnerId]?.currency ?? 'USD';
          }),
        ),
      ),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );

    this.subscriptions.push(
      this.productOrderFormService.cachedOrder$.subscribe((order) => {
        getInitInputValue(order, this.item);
      }),
    );
  }

  updateOrderItem(price): void {
    if (!price || !Number(price > 0)) {
      return;
    }
    price = convertCentsToDollars(price);
    this.subscriptions.push(
      this.productOrderFormService.cachedOrder$
        .pipe(
          take(1),
          map((order) => {
            updateOrderCustomPrice(price, order, this.item);
            return order;
          }),
        )
        .subscribe((order) => {
          this.productOrderFormService.cacheOrder(order);
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
